import { Injectable, OnDestroy } from "@angular/core";
import { Language } from "app/domains/language/language";
import { LanguageRepository } from "app/domains/language/language.repository";
import { Subscription, BehaviorSubject } from "rxjs";
import { HttpResourceResponse } from "../definitions/http-resource-response";
import { Socket } from "ngx-socket-io";

const LANGUAGES_KEY = 'app_languages';

@Injectable()
export class LanguageService implements OnDestroy {
  private languages$ = new BehaviorSubject<Language[]>([]);
  private subscription?: Subscription;
  private socketSubscription?: Subscription;

  constructor(
    private languageRepository: LanguageRepository,
    private socket: Socket
  ) {
    const storedLanguages = localStorage.getItem(LANGUAGES_KEY);

    if (storedLanguages) {
      this.languages$.next(JSON.parse(storedLanguages));
    } else {
      this.loadLanguages();
    }

    this.socketSubscription = this.socket
      .fromEvent(`model-saved.languages`)
      .subscribe(() => {
        this.loadLanguages();
      });
  }

 public loadLanguages(): void {
  this.subscription?.unsubscribe();

  this.subscription = this.languageRepository.all().subscribe({
    next: (response: HttpResourceResponse<Language[]>) => {
      const languages = response.body.data;

      // ✅ Aggiorna lo stream
      this.languages$.next(languages);

      // ✅ Controlla se c'erano lingue salvate
      const storedLanguagesJson = localStorage.getItem(LANGUAGES_KEY);
      if (storedLanguagesJson) {
        const storedLanguages: Language[] = JSON.parse(storedLanguagesJson);

        // Prendi gli ISO code validi dal backend
        const validIsoCodes = new Set(languages.map(lang => lang.iso_code));

        // Filtra solo le lingue ancora valide
        const cleanedLanguages = storedLanguages.filter(lang =>
          validIsoCodes.has(lang.iso_code)
        );

        // Salva le lingue ripulite
        localStorage.setItem(LANGUAGES_KEY, JSON.stringify(cleanedLanguages));
      } else {
        // Primo salvataggio se non esiste ancora niente
        localStorage.setItem(LANGUAGES_KEY, JSON.stringify(languages));
      }
    },
    error: () => {
      console.error('Failed to load languages');
    }
  });
}


  /**
   * Ottieni le lingue in formato Observable
   */
  public getLanguages$() {
    return this.languages$.asObservable();
  }

  /**
   * Ottieni le lingue in formato sincrono (snapshot)
   */
  public getLanguages(): Language[] {
    return this.languages$.getValue();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.socketSubscription?.unsubscribe();
  }
}
